import React from 'react';
import '../App.css';
import './services1.css';
import './app.css';
import './social_media_marketing.css';
import PopUp_Divs from './popup_divs.js'
import Purple_electric from '../images/social_media_marketing.mp4'; 
import { LiaClipboardListSolid } from "react-icons/lia";
import { GiGearHammer } from "react-icons/gi";
import { LuRocket } from "react-icons/lu";
import App from '../images/applications2.gif';
import Code from '../images/coding2.gif';
import Cross_Platform from '../images/responsive2.gif';
import Scale from '../images/scalability2.gif';
import Gear from '../images/gear2.gif'; 
import Strategy from '../images/strategy.gif'; 
import Statistics from '../images/statistics.gif'; 
import Add from '../images/advertising.gif';
import Mark_Auto from '../images/marketing_automation1.gif';
import { useScrollBehavior } from './useScrollBehavior.js';
import Footer from './footer.js' 


const Social_Media_Marketing = () => {

    useScrollBehavior();

     const ROUTES = {
      "Learn More": "/about",
      "Contact Us": "/contact2",
      "See Plans": "/about",
      "Get Support": "/contact2",
      "View Case Studies": "/portfolio",
    };
    
    React.useEffect(() => {
      const handler = (e) => {
        
        const el = e.target.closest('button, a, [role="button"], .btn, .button, .my-button-class, [data-button]');
        if (!el) return;
    
        const label = (el.textContent || "").trim();
        const path = ROUTES[label];
        if (!path) return;           
         sessionStorage.removeItem('scrollPosition');
       
        window.scrollTo(0, 0);
    
        e.preventDefault();          
        window.location.assign(path); 
      };
      
      document.addEventListener('click', handler, true);
      return () => document.removeEventListener('click', handler, true);
    }, []);
    
    return (
        <div id='services_div1'>
            <div className='module_service' id='service_moduleOne'>
                <video  autoPlay muted loop playsInline preload="auto" crossorigin="anonymous" fetchpriority="high">
                    <source src={Purple_electric} type="video/mp4" fetchpriority="high"/>
                        Your browser does not support the video tag.
                </video>
                <div id='services_heading1'><h1>Growth Marketing: Ads, Social & Email</h1>
                </div>
            </div>
            <div className='module_service' id='service_moduleTwo'>
                <div id='service_mod2_container'>
                    <div id='service_mod2_inner1'>
                        <h1 id='service_about_h1'>Performance Advertising & Digital Engagement</h1>
                        <h2>A Unified System Built to Acquire, Nurture, and Convert</h2>
                    </div>
                    <div id='service_mod2_inner2'>
                        <p>Paid advertising, social media, and email marketing only work when they 
                            operate as a coordinated system. We design and manage campaigns across 
                            Facebook, Google, and Instagram while aligning content, automation, 
                            and reporting to measurable business objectives. Every channel is 
                            structured around data budget allocation, audience targeting, 
                            creative testing, and ROI tracking so growth is predictable, scalable, and accountable.
                            </p>
                    </div>
                </div>

            </div>
             <div className='module_service' id='service_moduleTwo_app'>
                <div id='mod4_div2_service_app'>
                    <div id='mod4_div2_service_heading'>
                        <h1>From Strategy to Scale: Our Growth Marketing Framework</h1>
                        
                    </div>
                    <div id='mod4_sub_div_container_service'>
                        <div className='mod4_sub_div_service'>		
                                <div id='mod4_Sub_div_icon1_service'>
                                    {/*<img src={App} alt="App icon" className="plan" /> */}
                                    <img src={Strategy} alt="Strategy icon" className="plan" />
                                </div>
                                <h2>Ads Strategy & Management</h2>
                                <p>Strategic campaign planning across Facebook, Google, 
                                    and Instagram built around measurable objectives. 
                                    We structure targeting, bidding, creative testing, 
                                    and optimization to generate qualified traffic and 
                                    predictable returns.</p>
                        </div>
                        <div className='mod4_sub_div_service'>
                                <div id='mod4_Sub_div_icon2_service'>
                                    {/*<img src={Code} alt="Sales icon" className="sales" />*/}
                                    <img src={Scale} alt="Seo icon" className="seo" /> 
                                </div>		
                                <h2>Budget Allocation & Placement</h2>
                                <p>Budgets are distributed based on performance data, 
                                    audience behavior, and platform efficiency. We 
                                    continuously adjust placements and spending to 
                                    maximize reach, reduce waste, and improve cost per 
                                    acquisition.</p>
                        </div>
                        <div className='mod4_sub_div_service'>
                            <div id='mod4_Sub_div_icon3_service'>
                                {/*<img src={Cross_Platform} alt="Business icon" className="business" />*/}
                                <img src={Statistics} alt="Statistics icon" className="business" />
                            </div>
                            <h2>Competitor & Market Analysis</h2>
                            <p>Ongoing competitive tracking and market evaluation to identify positioning 
                                gaps, ad angles, and growth opportunities. Decisions are based on 
                                performance data—not assumptions.</p>
                        </div>
                        <div className='mod4_sub_div_service'>
                            <div id='mod4_Sub_div_icon4_service'>
                                {/*<img src={Scale} alt="Seo icon" className="seo" /> */}
                                <img src={Add} alt="Add icon" className="seo" />
                            </div>
                            <h2>Creative & Ad Development</h2>
                            <p>High-converting ad creative, including image, video, and copy 
                                development tailored to each platform. Messaging is aligned 
                                with brand positioning and optimized through controlled testing.</p>
                        </div>
                        <div className='mod4_sub_div_service'>
                            <div id='mod4_Sub_div_icon5_service'>
                                {/*<img src={Gear} alt="Website icon" className="website_list" />*/}
                                <img src={Code} alt="Sales icon" className="sales" />
                            </div>
                            <h2>Social Media Management</h2>
                            <p>Strategic profile setup, content planning, and consistent posting across 
                                Instagram, Facebook, YouTube, and LinkedIn to build authority, engagement,
                                and brand trust.</p>
                        </div>
                        <div className='mod4_sub_div_service'>
                            <div id='mod4_Sub_div_icon6_service'>
                                <img src={Mark_Auto} alt="Mark_Auto" className="boss" />
                            </div>
                            <h2>Email Marketing & Automation</h2>
                            <p>AI-assisted lead list generation, customized outreach campaigns, 
                                CRM integration, and performance reporting to nurture prospects and 
                                increase customer retention.
</p>
                        </div>
                    </div>

                </div>			
                
             </div>
             <div className='module_service' id='service_moduleThree'>
                <div id='service_mod2_container2_social'>
                    <div className="conversion-module_social">
                        <div id='conversion-module_subdiv_social'>
                            <h2>From Strategy to Scale, we build marketing systems that generate measurable growth.</h2>

                        <p>
                           We approach paid media, social, and email with one objective: turning attention into 
                           revenue. That means structured campaign planning, disciplined budget control, data-driven 
                           optimization, and reporting that ties performance directly to business outcomes. Our 
                           process ensures your marketing is not just active — it is engineered for sustainable 
                           scale.
                        </p>
                        </div>

                <div className="conversion-funnel">
                    <div className="step"><LiaClipboardListSolid  className="icon_social"/><strong>Plan:</strong> Define growth targets, audience segments, budget structure, and channel allocation.</div>
                    <div className="step"><GiGearHammer className="icon_social"/><strong>Build:</strong> Develop campaigns, creative assets, tracking systems, and automation workflows.</div>
                    <div className="step"><LuRocket className="icon_social"/><strong>Launch:</strong> Optimize performance, refine targeting, increase ROI, and expand winning channels.</div>
                </div>

                <ul className="conversion-points">
                    <li>Multi-platform ad management (Facebook, Instagram, Google)</li>
                    <li>Strategic budget allocation and placement optimization</li>
                    <li>Competitor tracking and performance benchmarking</li>
                    <li>Creative development for image, video, and copy</li>
                    <li>Social media management and content scheduling</li>
                    <li>AI-driven lead generation and email automation</li>
                    <li>Monthly ROI reporting with clear performance metrics</li>
                </ul>

                {/*<div className="conversion-ctas">
                    <div href="#contact" id='btn-primary' className="btn">Get a Free Quote</div>
                    <div href="#work" id='btn_service' className="btn">View Case Studies</div>
                </div>*/}
                </div>
                </div>
             </div>
            <div className='module_service' id='service_moduleFour'>
                
                <div id='mod4_div2_service'>
                    <div id='mod4_div2_service_heading'>
                        <h1>Transparent Packages & Performance Focus</h1>
                        <h1>From Strategy to Scale: Our Marketing System</h1>
                    </div>
                    <PopUp_Divs
                pageKey="social"
                data={[
                    { 
                        buttons: ["Learn More", "Contact Us"], 
                        h2: "Starter Growth System — $750/mo", 
                        p: "• Facebook & Instagram ad campaign setup\n• Basic ad creative development\n• Budget allocation strategy\n• Monthly performance report"
                    },
                    { 
                        buttons: ["See Plans", "Get Support"],
                        h2: "Growth Accelerator — $1,250/mo", 
                        p: "• Facebook, Instagram & Google Ads management\n• Competitor monitoring and optimization\n• Social media content scheduling\n• Creative testing and campaign refinement\n• Monthly ROI reports" 
                    },
                    { 
                        buttons: ["View Case Studies"],
                        h2: "Full Growth System — $2,000+/mo", 
                        p: "• Multi-platform ad management\n• AI lead generation & email campaigns\n• Social media management\n• Advanced reporting & strategy consulting\n• Ongoing campaign optimization" 
                    }
                  ]}
                />
                </div>
            </div>
            <Footer/>
            
        </div>
    );
};

export default Social_Media_Marketing;